let check_form_display = function () {
	let UA = window.navigator.userAgent,
		MSIE = UA.indexOf('MSIE '),
		Edge = UA.indexOf('Edge/');
	if (
		// Less than IE 10
		(MSIE > 0 && parseInt(UA.substring(MSIE + 5, UA.indexOf('.', MSIE))) < 10) ||
		// Less than Edge 12
		(Edge > 0 && parseInt(UA.substring(Edge + 5, UA.indexOf('.', Edge)), 10) <= 12)
	) {
		return false;
	}
	return true;
};

let formData = {
	form_name: '',
	form_obj: null,
	club_id: 0
};

function submit_form_checked()
{
	jQuery.ajax( {
		url: ajaxurl,
		type: 'POST',
		data: {
			action: 'recaptcha_validate',
			recaptcha_value: formData.form_obj.find('textarea[name="g-recaptcha-response"]').val()
		},
	}).done(function (data) {
		if (data == 'success') {
			form_submission(new FormData(formData.form_obj[0]), formData.form_name, formData.club_id);
		}
	}).fail(function () {
		grecaptcha.reset();
		formData.form_obj.removeClass('submitting');
		formData.form_obj.find('.form-footer').prepend('<div class="alert alert-warning" role="alert">'+translations.error+'</div>');
	});
}

let form_validator = function(form_name,form_club_disable) {

	// Form Variables
	formData.form_name = form_name;
	formData.form_obj = jQuery("#"+formData.form_name);

	// Parsley Validate
	formData.form_obj.parsley({
		classHandler: function(e) {
			let formGroupElement = e.$element;
			// apply parsley error class to parent element if element is a bootstrap select field, as actual element is hidden
			if (jQuery.inArray("inline-bs-select", e.$element[0].classList) !== -1) {formGroupElement = e.$element.parent();}
			return formGroupElement;
		}
	}).on('field:validated', function() {
		let ok = jQuery('.parsley-error').length === 0;
		jQuery('.bs-callout-warning').toggleClass('hidden', ok);
	}).on('form:submit', function() {
		form_submission_style(formData.form_obj);
		formData.club_id = formData.form_obj.find('input[name="ClubId"]').val();

		// Do not allow submission without Club ID
		if (form_club_disable !== 'disable' && !formData.club_id.length > 0) {
			alert(translations.clubIDDefined);
			return false;
		}

		// If recaptcha is disabled proceed without validating it
		if (window.location.href.indexOf('verify=false') !== -1 || getCookie('af_verify', "true") === "false" || getCookie('af_recaptcha_verify', "true") === "false") {
			form_submission(new FormData(formData.form_obj[0]), formData.form_name, formData.club_id);
		} else {
			grecaptcha.execute();
		}

		return false;
	});

};

let form_submission_style = function (this_form) {
	this_form.addClass('submitting');
	if (jQuery('#form-campaign-local-marketing-offer #submit').length) {
		jQuery('#form-campaign-local-marketing-offer #submit').prop("disabled", true); // disable button
		jQuery('#form-campaign-local-marketing-offer #submit').html( // add spinner to button
			jQuery('#form-campaign-local-marketing-offer #submit').html() +'<span class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>'
		);
	}
	this_form.find('.form-footer .alert-warning').remove();
};

let form_submission = function(form_data, form_name, club_id) {
	jQuery.ajax( {
		url: ajaxurl,
		type: 'POST',
		data: form_data,
		processData: false,
		contentType: false
	}).done(function (data) {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event':form_name,
				'club':club_id
			});
		}
		// Snippet: Form Success
		let club_name = '';
		if (jQuery(".form-club-location h2.h5 a").length) { // step 3 form without wizard
			club_name = jQuery(".form-club-location h2.h5 a").text();
		} else if (jQuery(".form-club-location h5").length) { // wizard step 3 form
			club_name = jQuery(".form-club-location h5").text();
		} else if (jQuery("select#location-city").length) { // form without club_id in url
			club_name = jQuery("select#location-city").find(":selected").text();
		} else if (jQuery("form input[name=club_name]").length) { // wizard campaign form
			club_name = jQuery("form input[name=club_name]").val();
		}
		submit_form_send_ga4_event(form_name, club_name, club_id);
		submit_form_send_segment_event(form_name, club_name, club_id);
		// end Snippet: Form Success
		let  club = '?club='+club_id;
		if (typeof pageFormValues.formSuccessURL !== 'undefined' && pageFormValues.formSuccessURL.length && pageFormValues.formSuccessURL.indexOf('thank-you-employee-wellness') !== -1) {
			club = '';
		}
		if (data > 1) {
			submit_identify_prospects_call_to_segment(data);
			club += '&schedule_id='+data;
			if (form_data.has('email_template') && (form_data.get('email_template') == 'nday-fplus-prospect' || form_data.get('email_template') == 'fplus-offer-prospect')) {
				if (form_data.get('email_template') == 'fplus-offer-prospect') {
					club += '&subscriber=1';
				} else if (form_data.get('email_template') == 'nday-fplus-prospect' && getCookie('fPlusLink', '') != '') {
					club += '&fPlusLink='+getCookie('fPlusLink');
					if (getCookie('fPlusCorrId', '') != '') {
						club += '&fPlusCorrId='+getCookie('fPlusCorrId');
					}
				}
				if (dynamicURLs.fPlusBookATourPage.length) {
					window.location.href = dynamicURLs.fPlusBookATourPage + club;
				} else {
					window.location.href = "/apple-fitness-plus-schedule-an-appointment/"+club;
				}
			} else if (dynamicURLs.bookATourPage.length) {
				if (getCookie('fPlusLink', '') != '') {
					club += '&fPlusLink='+getCookie('fPlusLink');
				}
				if (getCookie('fPlusCorrId', '') != '') {
					club += '&fPlusCorrId='+getCookie('fPlusCorrId');
				}
				window.location.href = dynamicURLs.bookATourPage + club;
			}
		} else {
			if (isNaN(data)) {
				grecaptcha.reset();
				formData.form_obj.removeClass('submitting');
				formData.form_obj.find('.form-footer').prepend('<div class="alert alert-warning" role="alert">'+translations.error+': '+data+'</div>');
			} else {
				if (form_data.has('appt_date') && form_data.has('appt_time')) {
					club += '&appt_date=' + form_data.get('appt_date') + '&appt_time=' + form_data.get('appt_time');
				}
				if (form_data.has('subscriber') && form_data.get('subscriber') == '1') {
					club += '&subscriber=1';
				} else if (form_data.has('fPlusLink') && form_data.get('fPlusLink') != '') {
					club += '&fPlusLink='+form_data.get('fPlusLink');
					if (form_data.has('fPlusCorrId') && form_data.get('fPlusCorrId') != '') {
						club += '&fPlusCorrId='+form_data.get('fPlusCorrId');
					}
				}
				window.location.href = typeof pageFormValues.formSuccessURL !== 'undefined' && pageFormValues.formSuccessURL.length
					? pageFormValues.formSuccessURL + club : '//' + window.location.hostname + '/thank-you/' + club;
			}
		}
	}).fail(function () {
		if ( typeof pageFormValues.formFailureURL !== 'undefined' && pageFormValues.formFailureURL.length ) {
			window.location.href = pageFormValues.formFailureURL+'?club='+club_id;
		} else {
			//TODO: Reset the submit button and display an error instead of redirecting
			let  club = '?club='+club_id;
			window.location.href = typeof pageFormValues.formSuccessURL !== 'undefined' && pageFormValues.formSuccessURL.length
				? pageFormValues.formSuccessURL+club : '//'+window.location.hostname+'/thank-you/'+club;
		}
	});

};

function submit_form_send_ga4_event(form_type, club_name, club_id)
{
	let ga4_obj = {
		'event' : 'form_success',
		'club_id' : club_id,
		'club_name' : club_name,
	};
	let ga4_obj_lead_category = 'grow', source_code = '';
	if (jQuery("form input[name=DigitalSource]").length > 0) {source_code = jQuery("form input[name=DigitalSource]").val();}
	switch (form_type) {
		case 'form-club-n-day-pass': // Free Trial Submit
		case 'form-club-7-day-pass': // Free Trial Submit
			ga4_obj = {...ga4_obj,
				'form_name' : 'free trial',
				'form_category' : 'lead',
				'lead_type' : 'global',
				'leads' : '1',
				'lead_source_code' : source_code ? source_code : 'Web-7day-7',
				'duration' : jQuery("#form-club-7-day-pass").data('pass-length') + ' day'
			};
			break;
		case 'form-nearby-gyms': // Fall Campaign Flow Submit
			ga4_obj = {...ga4_obj,
				'form_name' : 'campaign landing page',
				'form_category' : 'lead',
				'lead_type' : 'global',
				'leads' : '1',
				'lead_source_code' : source_code ? source_code : 'Web-7day-7',
				'duration' : jQuery("#form-club-7-day-pass").data('pass-length') + ' day'
			};
			break;
		case 'form-club-membership-inquiry': // Membership Inquiry Submit
			ga4_obj = {...ga4_obj,
				'form_name' : 'membership inquiry',
				'form_category' : 'lead',
				'lead_type' : 'global',
				'lead_source_code' : source_code ? source_code : 'Web-PreMembership',
				'leads' : '1'
			};
			break;
		case 'form-club-email': // Club Contact Submit
			ga4_obj = {...ga4_obj,
				'form_name' : 'contact club',
				'form_category' : 'non-nurtured lead',
				'lead_type' : 'global',
				'leads' : '1'
			};
			break;
		case 'formFitnessPlusTour':
		case 'formClubOfTheFuture': // Appointment Schedule Submit
			ga4_obj = {
				...ga4_obj,
				'form_name': 'schedule appointment',
				'lead_type': 'global',
				'lead_source_code': source_code
			};
			if (jQuery("form input[name=prospect_id]").length) { // User schedules appointment (after forms like "try us free", "Membership Inquiry", "local offers" and so on)
				ga4_obj = {...ga4_obj,
					'form_category' : 'schedule appointment',
					'leads' : 'undefined'
				};
			} else { // after click on Schedule a Tour button on LLP
				ga4_obj = {...ga4_obj,
					'form_category' : 'lead',
					'leads' : '1'
				};
			}
			break;
		case 'form-newton-trial': // Fitness+ Free Trial Submit
			ga4_obj = {
				...ga4_obj,
				'form_category' : 'lead',
				'lead_type' : 'global',
				'lead_source_code' : source_code,
				'leads' : '1'
			};
			if (source_code == 'Web-FitnessPlusSubscriber') { // Subscriber flow
				ga4_obj['form_name'] = 'fitness plus subscriber';
			} else { // trial flow
				ga4_obj['form_name'] = 'fitness plus free trial';
			}
			break;
		case 'form-campaign-local-marketing-offer': // Local Lead Submit
			if (source_code == 'Website-Local-0Enrollment' || source_code == 'Website-Local-FoundersRate') {
				ga4_obj_lead_category = 'ramp';
			}
			ga4_obj = {...ga4_obj,
				'form_name' : jQuery(".offer-overview-container h1.display-heading").text(),
				'form_category' : 'lead',
				'lead_type' : 'local',
				'lead_category' : ga4_obj_lead_category,
				'lead_source_code' : source_code,
				'leads' : '1'
			};
			break;
		case 'form-blackfriday-landing': // Black Friday Landing Page Flow Submit
		case 'form-seasonal-landing': // Seasonal Offer Landing Page Flow Submit
			ga4_obj = {...ga4_obj,
				'form_name' : (form_type === 'form-blackfriday-landing' ? 'black friday' : 'seasonal')+' offer',
				'form_category' : 'lead',
				'lead_type' : 'global',
				'lead_category' : ga4_obj_lead_category,
				'lead_source_code' : source_code,
				'leads' : '1'
			};
			break;
		case 'campaignClubForm': // Local Campaign (Legacy) Form Submit
		case 'form-campaign-offer': // Local Campaign (Legacy) Form Submit
		case 'form-campaign-refresh-offer': // Local Campaign (Legacy) Form Submit
			ga4_obj = {...ga4_obj,
				'form_name' : 'Legacy: ' + location.pathname.replaceAll("-", " ").replaceAll("/", ""),
				'lead_type' : 'local',
				'lead_category' : 'grow',
				'lead_source_code' : source_code,
				'form_category' : 'lead',
				'leads' : '1'
			};
			break;
		case 'form-club-feedback': // Feedback Form Submit
			ga4_obj = {...ga4_obj,
				'form_name' : 'club feedback',
				'lead_type' : 'global',
				'form_category' : 'lead',
				'leads' : '1'
			};
			break;
		default:
			console.log('unknown form: ' + form_type);
	}

	if (Object.keys(ga4_obj).length) {
		(window.dataLayer=window.dataLayer||[]).push(ga4_obj);
	}
}

function submit_form_send_segment_event(form_type, club_name, club_id)
{
	let UTMs = [];
	UTMs['utm_campaign'] = '';
	UTMs['utm_medium'] = '';
	UTMs['utm_source'] = '';

	if (jQuery("form input[name=gtm_campaign_url]").length && jQuery("form input[name=gtm_campaign_url]").val() != '') {
		jQuery("form input[name=gtm_campaign_url]").val().replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
			UTMs[key] = value;
		});
		jQuery.each(UTMs, function (index, UTM) {
			if(index == 'utm_campaign') {
				UTMs['utm_campaign'] = UTM;
			}
			if(index == 'utm_medium') {
				UTMs['utm_medium'] = UTM;
			}
			if(index == 'utm_source') {
				UTMs['utm_source'] = UTM;
			}
		});
	}
	let segment_obj = {
		"brand": 			"anytimefitness",
		"brand_channel": 	"website",
		"location_id": 		club_id,
		"location_name": 	club_name,
		"page_name": 		document.title,
		"page_path": 		window.location.href,
		"utm_campaign": 	UTMs['utm_campaign'],
		"utm_medium": 		UTMs['utm_medium'],
		"utm_source": 		UTMs['utm_source'],
		"lead_form_data": (new FormData(formData.form_obj[0]))
	};
	let source_code = '', segment_lead = true, segment_tour = false;
	if (jQuery("form input[name=DigitalSource]").length > 0) {source_code = jQuery("form input[name=DigitalSource]").val();}
	switch (form_type) {
		case 'form-club-n-day-pass': // Free Trial Submit
		case 'form-club-7-day-pass': // Free Trial Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-club-7-day-pass .btn-submit-form").text()),
			};
			if (jQuery("form input[name=referral_member_id]").length) { // referral flow
				segment_obj = {...segment_obj,
					"lead_name": "referral flow",
					"lead_type": "referral",
					"referral_member_id": jQuery("form input[name=referral_member_id]").val(),
				};
			} else { // try us free flow
				segment_obj = {...segment_obj,
					"lead_name": "free trial",
					"lead_type": "trial",
				};
			}
			break;
		case 'form-nearby-gyms': // Fall Campaign Flow Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-club-7-day-pass .btn-submit-form").text()),
				"lead_name": "campaign landing page",
				"lead_type": "trial",
			}
			break;
		case 'form-club-membership-inquiry': // Membership Inquiry Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-club-membership-inquiry .btn-submit-form").text()),
				"lead_name": "membership inquiry",
				"lead_type": "membership-inquiry",
			};
			break;
		case 'form-club-email': // Club Contact Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-club-email .btn-submit-form").text()),
				"lead_name": "contact club",
				"lead_type": "email",
			};
			break;
		case 'formFitnessPlusTour':
		case 'formClubOfTheFuture': // Appointment Schedule Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery(".btn-submit-form").text()),
				"lead_type": "schedule-appointment-" + jQuery("form").attr("id"),
			};
			segment_tour = true;
			if (jQuery("form input[name=prospect_id]").length) { // User schedules appointment
				segment_obj = {...segment_obj,
					"lead_name": jQuery("form").attr("id") + " book a tour form"
				};
				segment_lead = false;
			} else {  // after click on Schedule a Tour button on LLP
				segment_obj = {...segment_obj,
					"lead_name": "book a tour standalone"
				};
			}
			break;
		case 'form-newton-trial': // Fitness+ Free Trial Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-newton-trial .btn-submit-form").text()),
				"lead_type": "form-newton-trial",
			};
			if (source_code == 'Web-FitnessPlusSubscriber') { // Subscriber flow
				segment_obj['lead_name'] = 'fitness plus subscriber';
			} else { // trial flow
				segment_obj['lead_name'] = 'fitness plus free trial';
			}
			break;
		case 'form-campaign-local-marketing-offer': // Local Lead Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-campaign-local-marketing-offer .btn-submit-form").text()),
				"lead_name": jQuery(".offer-overview-container h1.display-heading").text(),
				"lead_type": "local-offer",
			};
			break;
		case 'form-blackfriday-landing': // Black Friday Landing Page Flow Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-blackfriday-landing .btn-submit-form").text()),
				"lead_name": 'black friday offer',
				"lead_type": "local-offer",
			};
			break;
		case 'form-seasonal-landing': // Seasonal Offer Landing Page Flow Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-seasonal-landing .btn-submit-form").text()),
				"lead_name": 'seasonal offer',
				"lead_type": "local-offer",
			};
			break;
		case 'campaignClubForm': // Local Campaign (Legacy) Form Submit
		case 'form-campaign-offer': // Local Campaign (Legacy) Form Submit
		case 'form-campaign-refresh-offer': // Local Campaign (Legacy) Form Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery(".form-body form button[type=submit]").text()),
				"lead_name": 'Legacy: ' + location.pathname.replaceAll("-", " ").replaceAll("/", ""),
				"lead_type": "local-offer-legacy",
			};
			break;
		case 'form-club-feedback': // Feedback Form Submit
			segment_obj = {...segment_obj,
				"cta": jQuery.trim(jQuery("#form-club-feedback .btn-submit-form").text()),
				"lead_name": "club feedback",
				"lead_type": "feedback",
			};
			break;
		default:
			console.log('unknown form: ' + form_type);
	}

	if (typeof analytics != "undefined") {
		if (segment_lead) analytics.track("Lead Submitted", segment_obj); //trigger for all except BAT 2nd step
		if (segment_tour) analytics.track("Lead Appointment Scheduled", segment_obj); //trigger for all BAT, even standalone
	}
}
function submit_identify_prospects_call_to_segment(data) {
	let object = {};
	object = {
		"location_id": formData.club_id,
		"address": {
			"postal_code": formData.form_obj.find('#PostCode').val()
		},
		"email": formData.form_obj.find('#email').val(),
		"first_name": formData.form_obj.find('#firstname').val(),
		"last_name": formData.form_obj.find('#lastname').val(),
		"phone": formData.form_obj.find('#phone').val(),
		"prospect_id": data
	};
	if (typeof analytics != "undefined") {
		analytics.identify(null, object);
	}
}